module.exports = __webpack_public_path__ + "img/42.88f69275.png";